var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.9997C3 20.2453 4.75439 21.9997 7 21.9997H17C19.2456 21.9997 21 20.2453 21 17.9997V11.9997C21 9.75412 19.2456 7.99973 17 7.99973H7C4.75439 7.99973 3 9.75412 3 11.9997V17.9997ZM10 14.9997C10 13.8945 10.8947 12.9997 12 12.9997C13.1053 12.9997 14 13.8945 14 14.9997C14 16.105 13.1053 16.9997 12 16.9997C10.8947 16.9997 10 16.105 10 14.9997ZM16 8.99973V5.99973C16 5.21026 15.7544 4.42078 15.3158 3.77166C14.8772 3.14008 14.2632 2.61376 13.5263 2.29797C12.807 1.99973 11.9825 1.92955 11.2281 2.06991C10.4386 2.2278 9.73684 2.61376 9.17544 3.17517C8.98246 3.35061 8.87719 3.59622 8.87719 3.87692C8.87719 4.42078 9.33333 4.87692 9.87719 4.87692C10.1579 4.87692 10.4035 4.77166 10.5789 4.57868C10.8947 4.26289 11.1579 4.12254 11.614 4.03482C12.0526 3.9471 12.3509 3.98219 12.7544 4.15762C13.1754 4.31552 13.4035 4.5085 13.6667 4.89447C13.9123 5.26289 14 5.54359 14 5.99973V8.99973C14 9.54359 14.4561 9.99973 15 9.99973C15.5439 9.99973 16 9.54359 16 8.99973Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock_open.4c818eb7.svg";
export { ForwardRef as ReactComponent };